<template>
  <div class = "container" id="details">
    <v-tooltip bottom dark color="#333">
      <template v-slot:activator="{ on }">
        <div class="back">
          <button v-on="on" class="soup-btn" @click="backToSoup">
            <v-icon large>mdi-arrow-left-circle</v-icon>
          </button>
        </div>
      </template>
      <span class="tooltip-text">Back</span>
      <span class="key">
        <span class="key-inner">esc</span>
      </span>
    </v-tooltip>
    <v-row justify="center" v-if="storeState.details.type === 'card'">
      <v-col cols="12" offset="1" sm="10" md="10">
        <v-card
          class="mx-auto details-card"
        >
          <v-row>
            <v-col cols="12" sm="9" md="9">
                <div 
                  @mouseenter="showCopyEmail=true"
                  @mouseleave="showCopyEmail=false"
                  class="card-head"
                >
                  {{storeState.details.email}}
                  <span v-if="showCopyEmail">
                    <button @click="copyEmail" class="soup-btn pl-2">
                      <v-icon small>mdi-content-copy</v-icon>
                    </button>
                  </span>
                </div>
                <div>
                  Joined {{joinedOn(storeState.details.created_on)}} {{trialStatus(storeState.details)}} current state is {{storeState.details.state}}
                </div>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="text-right">
              <v-tooltip right dark color="#333">
                <template v-slot:activator="{ on }">
                    <div class="reminder" v-on="on" @click="addReminder">
                      <v-icon :color="pastDue(storeState.editableDetails.reminder).color" class="clock" size="16px">mdi-alarm</v-icon>
                      <span 
                        :class="{'reminder-text': true, 'red': pastDue(storeState.editableDetails.reminder).red}"
                        v-if="storeState.editableDetails.reminder"
                      >
                        {{getFromNowDt(storeState.editableDetails.reminder)}}
                      </span>
                    </div>
                </template>
                <span>Reminder
                  <span class="key">
                    <span class="key-inner">R</span>
                  </span>
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-card-text>
            <div v-if="storeState.details.team_members > 0">
              {{storeState.details.team_name}} has {{storeState.details.team_members}} user{{storeState.details.team_members > 1 ? 's' : ''}}
              and is on a {{storeState.details.plan_type}} plan. This user is a {{storeState.details.team_role}}  on  {{storeState.details.team_name}}.
              <span v-if="!moreDetails" @click="moreDetails=true" class="more-link">More details</span>
              <span v-else @click="moreDetails=false" class="more-link">Less details</span>
            </div>
            <div v-else>
              User is not on a team, {{storeState.details.plan}} plan. <span>More</span>
            </div>

            <div v-if="moreDetails">
              <v-row >
                <v-col cols="12" sm="3" md="3" v-for="(value, name) in storeState.details" v-bind:key="name">
                  {{ name }}: {{ value }}
                </v-col>
              </v-row>
            </div>
            <div class = "timeline-container">
              <template>
                <v-timeline dense clipped>
                  <v-timeline-item small>Converted to paid</v-timeline-item>
                  <v-timeline-item small fill-dot color="#eee">First schedule</v-timeline-item>
                  <v-timeline-item small>Created</v-timeline-item>
                </v-timeline>
              </template>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text>Update plan</v-btn>
            <v-btn @click="getSchedules" text>Schedules</v-btn>
            <v-btn @click="this.$parent.openIntercom" text>Intercom</v-btn>
            <v-btn @click="this.$parent.openFullStory" text>FullStory</v-btn>
            <v-btn @click="this.$parent.openStripe" text>Stripe</v-btn>
            <v-btn @click="getEvents" text>Events</v-btn>
            <v-btn @click="loginAs" text>Login as</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-hover
        v-slot:default="{ hover }"
        :open-delay="0"
        :close-delay="0"
        :disabled="false"
        :value="false"
      >
        <v-row justify="center" v-if="storeState.details.type === 'card'">
          <v-col cols="12" offset="1" sm="10" md="10">
            <template>
              <v-combobox
                ref="tagCombobox"
                v-model="storeState.editableDetails.tags"
                :items="storeState.allTags"
                chips
                label="Tags"
                multiple
                single-line
                auto-select-first
                hide-selected
                :rules="tagRules"
                :search-input.sync="tagInput"
                append-icon=''
                @keyup.native.enter="tagAddedEnter()"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected.text"
                    close
                    dense
                    close-icon="mdi-close"
                    label
                    @click="selectTag"
                    @click:close="removeTag(item)"
                  >
                    {{ item.text }}
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No existing tags for "<strong>{{ tagInput }}</strong>" <v-btn class="create-tag" @click="createTag(tagInput)">create one?</v-btn>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </template>
          </v-col>
        </v-row>
      </v-hover>
    </div>
    <div>
      <v-row justify="center" v-if="storeState.details.type === 'card'">
        <v-col cols="12" offset="1" sm="10" md="10">
          <comment-div></comment-div>
          <!-- <div v-for="(comment, index) in comments" :key="index">
            <comment-div v-bind="{text: 'this'}">
              {{comment.text}}
            </comment-div>
          </div> -->
        </v-col>
      </v-row>
    </div>
    <div v-if="storeState.details.type === 'table'">
      <v-data-table
        :headers="storeState.details.tableHeaders"
        :items="storeState.details.table"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{storeState.details.subType}} ({{storeState.details.email}})</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <div class="flex-grow-1"></div>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Blah</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="closeEdit">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="saveEdit">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          No results
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import InputTag from 'vue-input-tag'
import Comment from './Comment'
import { store } from '../store.js';
Vue.component('input-tag', InputTag);
Vue.component('comment-div', Comment);

document.body.setAttribute('data-app', true)

export default {
  mounted() {
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      editableDetails: store.state.editableDetails,
      moreDetails: false,
      showCopyEmail: false,
      tagRules: [
        v => false
      ],
      tagInput: '',
      editingTag: false,
      editingComment: false,
      commentTitle: 'Mike ' + this.getFromNow(1568851200000),
      chip1: true,
      editedItem: {},
      dialog: false,
      
      searchIndex: 0,
      searchTerm: '',
      newTag: '',
      searchIn: [],
      searchResults: [],
      consumedOn: new Date().toISOString().substr(0, 10),
      consumedOnCal: false,
      addingFood: false,
      removingFood: false,
      expanded: [],
      checked: [],
      amount: '',
      userEntries: [],
      userEntriesHeader: [], 
      loadingUserData: false,
      loading: true,
      selectedFood: false,
      unit: 'g',
      headers: [],
      foodFacts: [],
      amountRules: [
        value => !!value || 'Required.',
        value => !isNaN(value) || 'Enter a number'
      ],
    };
  },
  filters: {
    dateFilter: function (date) {
      console.log(date)
      date = date.fromNow()
      return date
      // return moment(date).fromNow();
    }
  },
  components: {
  },
  watch: {
    'editableDetails.tags': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    },
    'editableDetails.comments': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    },
    'editableDetails.reminder': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    }
  },
  methods: {
    createTag(tag) {
      console.log(tag)
      this.storeState.addingTag = true
      this.storeState.cmdkParentCmd = 'createTag'
      this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
    },
    getEvents() {
      store.runDetails({model: 'events'})
      this.$router.push({ path: '/table' }).catch(err => {})
    },
    loginAs() {
      window.localStorage.removeItem('sessionId');
      store.runDetails({model: 'sessionId'})
    },
    getSchedules() {
      store.runDetails({model: 'schedules'})
      this.$router.push({ path: '/table' }).catch(err => {})
    },
    backToSoup() {
      this.$router.go(-1);
    },
    copyToClipboard (text) {
      let testingCodeToCopy = document.querySelector('#copytoclipboard')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
      } catch (err) {
        console.error('Oops, unable to copy');
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    copyEmail() {
      this.$copyText(this.storeState.details.email)
      this.storeState.snackbar = true;
      this.storeState.message = 'Copied!';
    },
    tagAddedEnter() {
      console.log('this.tagInput: ', this.tagInput, this.editableDetails.tags)
      this.editableDetails.tags = this.editableDetails.tags.filter(el => el && el.text && el.text.length > 0)
      // for (let i = 0; i < this.tags.length; i++) {
      //   let el = this.tags[i];
      //   if (el && el.text && el.text.length > 0)
      // }
      this.tagInput = ''
    },
    editTag(index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    // openCmdkReminder() {
    //   // this.$parent.changeFocus('cmdk', this)
    //   // this.storeState.searchIndex = 0
    //   // this.storeState.cmdkParentCmd = 'addReminder'
    //   this.$parent.cmdkActive = true;
    // },
    addReminder(e) {
      this.storeState.cmdkParentCmd = 'addReminder'
      this.$parent.openCmdK({cmdkParentCmd: 'addReminder', cmdkInput: ''})
      console.log('cmdk: ', e)
    },
    removeTag(item) {
      this.storeState.editableDetails.tags.splice(this.storeState.editableDetails.tags.indexOf(item), 1)
      this.storeState.editableDetails.tags = [...this.storeState.editableDetails.tags]
    },
    selectTag(item) {

    },
    getFromNowDt(date) {
      console.log(date)
      return moment(date).fromNow();
    },
    pastDue(date) {
      let red = moment(date).isSameOrBefore(moment())
      if (date) return {red: red, color: red ? '#eb5757' : '#2eaadc'};
      return {red: false, color: '#000000de'}
    },
    joinedOn(date) {
      // return moment(Number(date)).format('MMMM Do YYYY')
      return moment(date).format('MMMM Do YYYY')
    },
    trialStatus(details) {
      // return moment(Number(date)).format('MMMM Do YYYY')
      this.storeState.details.trialExpired = false
      let now = moment()
      let trialStart = moment(details.created_on)
      let days = now.diff(trialStart, "days")
      if (days >= 14 && (['trial', 'basic'].includes(details.plan_type))) {
        this.storeState.details.trialExpired = true
        return ' (Trial expired)'
      } else if ((['trial', 'basic'].includes(details.plan_type)))  {
        return ` (${14 - days} days left on trial)`
      }
      return ''
    },
    getFromNow(date) {
      return moment(Number(date)).fromNow();
    },
    closeEdit(d) {
      console.log('closeEdit: ', d)
    },
    saveEdit(d) {
      console.log('saveEdit: ', d)
    },
    moment: function () {
      return moment();
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    getTags() {
      console.log('val term: ', this.newTag)
    },
    search(e) {
      console.log('search term: ', this.searchTerm, e)
      if (e.keyCode === 13) { //enter
        console.log('hit enter...')
        return
      }
      var self = this
      // window.db.users.where('email').startsWithIgnoreCase(this.searchTerm).toArray(function(result) {
      //   console.log("Found: " + result.length);
      //   self.searchResults = result.slice(0, 20)
      // });
      // db.users.filter (function (user) { return user.email.includes(self.searchTerm) })
      //   .toArray()
      //   .then(function(result) {
      //     console.log(result)
      //     self.searchResults = result.slice(0, 20)
      //   });
      // debugger
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.includes(this.searchTerm)).slice(0, 20)
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.startsWith(this.searchTerm)).slice(0, 20)
      // debugger
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.includes(this.searchTerm)).slice(0, 20)
      function successHandler(tx, results) {
        var arr = []
        console.log('found: ', results.rows.length)
        for (let i = 0; i < results.rows.length; i++) {
          let row = results.rows.item([i]);
          arr.push(row)
        }
        self.searchResults = arr
      }
      function errorHandler(transaction, error) {
        console.log(`Error : ${error.message}`);
      }
      function execSql(db, sql, q, successHandler) {
        db.transaction(function (tx) { 
            tx.executeSql(sql, [], successHandler, errorHandler); 
        })
      }
      // execSql(this.storeState.db, `SELECT * FROM users WHERE users MATCH '${this.searchTerm}' LIMIT 20`, '', successHandler)
      let sql = `SELECT * FROM users WHERE LOWER(email) LIKE '%${this.searchTerm}%' LIMIT 20`
      // debugger
      execSql(this.storeState.db, sql, '', successHandler)
      
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  created() {
  },
};
</script>

<style>
.active {
  background-color: #eee;
}
.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.container {
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 20px;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.sub-title {
  font-size: 16px;
  padding-top: 0px;
}
.timeline-container {
  padding-top: 30px;
  padding-bottom: 10px;
}
.details-card {
  padding-left: 30px;
  padding-right: 30px;
}
.tag {
  margin-left: 0px;
}
.tag2 {
  margin-left: 15px;
}
.comment-text {
  color: rgba(0, 0, 0, 0.87);
}
.comment-title {
  font-size: 14px;
  font-weight: 700;
}
.comment-time {
  font-size: 12px;
  color: rgba(55, 53, 47, 0.4);
  font-weight: normal;
}
.card-head {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
}
.more-link {
  color: rgb(46, 170, 220);
  cursor: pointer;
}
.reminder {
  color: rgb(46, 170, 220);
  cursor: pointer;
}
.clock {
  margin-bottom: 2px;
}
.reminder-text {
  margin-left: 5px;
}
.create-tag {
  margin-left: 15px;
}

</style>
